"use client";
import LocalAPIManager from "@/utils/LocalAPIManager";
import { toastError, toastInfo } from "@/utils/ToastsManager";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
// import BackendManager from "@/app/Utils/BackendManager";

import { addConfirmSignUpListener } from "@/utils/AWS/AWSClientLoader";
import { IBackendManagerInterface } from "@/utils/BackendManager";
import dynamic from "next/dynamic";
const SimpleTextInput = dynamic(
  () => import("@/components/ui/Input/SimpleTextInput"),
  {
    ssr: false,
  }
);
var BackendManager: IBackendManagerInterface;
import("@/utils/BackendManager").then((lib) => {
  BackendManager = lib.default;
});

type Props = {
  email: string;
  password: string;
  isVerifyingWithLink: boolean;
};

export default function ConfirmSignUp({
  email,
  password,
  isVerifyingWithLink,
}: Props) {
  const [loading, setLoading] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const router = useRouter();
  useEffect(() => {
    addConfirmSignUpListener(() => {
      postConfirmationLogin();
    });
  }, []);

  async function confirmUser() {
    setLoading(true);
    try {
      await LocalAPIManager.signupCodeConfirmation(email, verificationCode);
      await BackendManager.logIn(email, password);
      router.push(`/`);
    } catch (error) {
      toastError("Whoops! failed to confirm user....");
    }
    setLoading(false);
  }
  async function resendConfirmationLink() {
    setLoading(true);
    try {
      await LocalAPIManager.signupResendConfirmation(email);
      toastInfo("confirmation email resent");
    } catch (error) {
      toastError("Whoops! failed to send recovery email....");
    }
    setLoading(false);
  }
  async function postConfirmationLogin() {
    try {
      await BackendManager.logIn(email, password);
      router.push(`/`);
    } catch {
      router.push(`/login`);
    }
  }
  const loadingStyle = "loading-md loading loading-dots text-secondary";
  function renderLinkVerification() {
    return (
      <div>
        <p className="mt-2 text-secondary-content ">
          Please check your email, click the link you were sent then login
          <button
            className="mx-1 font-bold text-primary  transition-all duration-200 hover:text-[color-mix(in_oklab,oklch(var(--p)),black_7%)] hover:underline "
            onClick={async () => {
              postConfirmationLogin();
            }}
          >
            here
          </button>
        </p>

        <div className="mt-4 space-y-2">
          <p className="font-bold text-secondary-content ">{`Didn't get one?`}</p>
          <div>
            <button
              onClick={async () => {
                resendConfirmationLink();
              }}
              className={`btn ${
                loading ? "btn-disabled" : ""
              } inline-flex w-full items-center justify-center rounded-md border border-transparent bg-gradient-to-r from-primary to-[color-mix(in_oklab,oklch(var(--p)),black_7%)] text-base font-semibold normal-case text-white transition-all duration-200 hover:opacity-90 focus:opacity-90 focus:outline-none`}
            >
              {loading && <span className={`${loadingStyle}`}></span>}
              Resend verification link
            </button>
          </div>
        </div>
      </div>
    );
  }
  function renderCodeVerification() {
    return (
      <div>
        <SimpleTextInput
          inputType="email"
          title=""
          placeholder="Confirmation Code"
          value={verificationCode}
          onChange={(newValue) => {
            setVerificationCode(newValue);
          }}
          pathD="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
          supplementaryAnchorText="Resend Code?"
          onSupplementaryAnchorClick={async () => {
            if (loading == true) {
              return;
            }
            setLoading(true);
            await LocalAPIManager.signupResendConfirmation(email);
            setLoading(false);
            toastInfo("confirmation Code resent");
          }}
        />

        <div>
          <button
            onClick={() => {
              confirmUser();
            }}
            className={`btn ${
              loading ? "loading" : ""
            } inline-flex w-full items-center justify-center rounded-md border border-transparent bg-gradient-to-r from-secondary to-[color-mix(in_oklab,oklch(var(--s)),black_7%)] text-base font-semibold text-white transition-all duration-200 hover:opacity-90 focus:opacity-90 focus:outline-none`}
          >
            Confirm
          </button>
        </div>
      </div>
    );
  }

  return (
    <section className="mx-auto max-w-xl">
      <div>
        <div className="flex items-center justify-center sm:px-6 lg:px-8  ">
          <div className="rounded-md bg-secondary p-8 text-primary-content shadow-md shadow-neutral">
            <h1 className="mx-auto mb-1 text-xl font-bold leading-tight tracking-tight transition-all  sm:text-4xl">
              Confirm Your account
            </h1>
            <div>
              {isVerifyingWithLink == true && renderLinkVerification()}
              {isVerifyingWithLink == false && renderCodeVerification()}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
